import { SimpleIndustriousLocationSearchDto } from '@/lib/locations/dto';

import { ApplicationFormType } from './FormWithBackgroundModule/ApplicationForm/form-schema';
import { BrokerFormType } from './FormWithBackgroundModule/BrokerForm/form-schema';
import { RegularFormType } from './FormWithBackgroundModule/RegularForm/form-schema';
import { ModuleTypes } from './module-types.enum';

export type BaseModuleProps = {
  name: ModuleTypes;
  background?:
    | BackgroundColorProps
    | BackgroundImageProps
    | BackgroundVideoProps;
  isHidden?: boolean;
};

export type LinkProps = {
  url: string;
  label: string;
};

/* Medias */
export type ImageProps = {
  src: string;
  alt: string;
  caption?: string;
  priority?: boolean;
  sizes?: string;
  className?: string;
};

export type VideoProps = {
  src: string;
  type: 'video/mp4' | 'video/webm' | 'video/ogg';
};

/* Backgrounds */
export enum BackgroundType {
  Image = 'image',
  Video = 'video',
  Color = 'color',
}

export enum BackgroundColors {
  ALMOND = 'almond',
  WHITE = 'white',
}

export type BackgroundImageProps = {
  type: BackgroundType.Image;
  image: ImageProps;
};

export type BackgroundVideoProps = {
  type: BackgroundType.Video;
  video: VideoProps;
};

export type BackgroundColorProps = {
  type: BackgroundType.Color;
  color: BackgroundColors;
};

/* Eyebrow */
export enum EyebrowType {
  Text = 'text',
  Image = 'image',
}

export type TextEyebrowProps = {
  type: EyebrowType.Text;
  text: string;
};

export type ImageEyebrowProps = ImageProps & {
  type: EyebrowType.Image;
};

/* Forms */
export enum FormWithBackgroundType {
  Regular = 'regular',
  Broker = 'broker',
  Application = 'application',
}

export type RegularFormData = Omit<RegularFormType, 'locationSfId'> & {
  location: SimpleIndustriousLocationSearchDto;
};

export type ApplicationFormData = Omit<ApplicationFormType, 'locationSfId'> & {
  location: SimpleIndustriousLocationSearchDto;
};

export type BrokerFormData = BrokerFormType;

export type FormWithBackgroundData =
  | ApplicationFormData
  | RegularFormData
  | BrokerFormData;
